import {useTranslation} from 'react-i18next';
import {Outlet} from 'react-router-dom';
import {Suspense, useRef} from 'react';
import {Globe} from 'lucide-react';
import {ViewLoader} from 'pages/Auth/components/ViewLoader';
import {PrivacyPolicyLink} from 'components/PrivacyPolicyLink';
import {
  LanguageSelection,
  LanguageSelectionRef,
} from 'components/ModalSheets/LanguageSelection/LanguageSelection';
import styles from './styles.module.css';
import usePropertyLinkInfo from 'hooks/guidebooks/usePropertyLinkInfo';
import chekinLogo from 'assets/icons/accept-icon.svg';

function WelcomeLayout() {
  const {t} = useTranslation();
  const languageSelectionModalRef = useRef<LanguageSelectionRef>(null);
  const {title, logo: hostLogo} = usePropertyLinkInfo();
  const logo = hostLogo || chekinLogo;
  return (
    <>
      <div className={styles.welcomeLayout_wrapper}>
        <header className={styles.welcomeLayout_header}>
          <div className={styles.welcomeLayout_logo}>
            <img src={logo} alt="logo" width={48} height={48} />
          </div>
          <span className={styles.welcomeLayout_propertyName}>{title}</span>
        </header>
        <main className={styles.welcomeLayout_main}>
          <Suspense fallback={<ViewLoader />}>
            <Outlet />
          </Suspense>
        </main>
        <footer className={styles.welcomeLayout_footer}>
          <div className={styles.welcomeLayout_footerLinks}>
            <PrivacyPolicyLink className={'font-medium'} />
            <div className={styles.welcomeLayout_footerDivider} />
            <button
              className={styles.welcomeLayout_languageButton}
              onClick={() => languageSelectionModalRef.current?.open()}
              type="button"
              aria-label={`${t('language')}`}
            >
              <Globe size={16} className={styles.welcomeLayout_languageIcon} />
              <span className={styles.welcomeLayout_languageLabel}>{t('language')}</span>
            </button>
          </div>
        </footer>
      </div>
      <LanguageSelection ref={languageSelectionModalRef} />
    </>
  );
}

export {WelcomeLayout};
